<template>
    <div class="form-field">
        <label>类型</label>
        <div class="content">
            <el-select class="select" :value="type" @input="setCompType" placeholder="类型" size="mini">
                <el-option
                        v-for="item in typeList"
                        :key="item"
                        :value="item">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-field {
        align-items: center;
        .content {
            position: relative;
            :global(.el-select) {
                width: 150px;
            }
            :global(input) {
                width: 150px;
                max-width: 150px;
            }
        }
    }

    .options {
        /*margin-top: 5px;*/
    }

    .select {
        width: 90px;
    }
</style>

<script>
	import style from 'mixins/style'
	import _ from 'lodash'
	import {createFont} from 'utils/helper'

	export default {
		computed: {
			type() {
				return this.selected.type
			},
			selected() {
				return this.$store.state.selected
			},
			typeList() {
				if (this.type === 'image' || this.type === 'logo' || this.type === 'icon') {
					return [
						'image', 'logo', 'icon'
					]
				} else {
					return [
						'text', 'title', 'digest', 'advertuser'
					]
				}
			}
		},
		methods: {
			setCompType(value) {
				let data = {
					type: value
				}
				if(this.selected.isDynamic){
					if (value !== 'text' || value !== 'image') {
						if (value === 'icon' || value === 'logo') {
							data.content = ''
						} else {
							data.content = `\${${value}}`
						}
					}
                }
				this.$store.commit('update_elm', {
					id: this.selected.id,
					data
				})
				this.$store.dispatch('elm_select', {id: this.selected.id})
			}
		}
	}
</script>
